import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../../../services/http.service";

const CHATBOT = `/openai-chat`;


export const createConversation = createAsyncThunk(
  "createConversation",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${CHATBOT}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getChatList = createAsyncThunk(
  "getChatList",
  async ({ uuid }: { uuid: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${CHATBOT}/${uuid}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const chatWithOpenAi = createAsyncThunk(
  "chatWithOpenAi",
  async ({ uuid, message }: { uuid: string , message: any}, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${CHATBOT}/${uuid}`, { message });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

